import React, { useEffect, useState } from 'react';
import apiService from '../APIService';



const UploadFile = (props) => {
    const [selected,setSelected] = useState("Choose File");
    const [showError,setShowError] = useState(false)
    const [sizeError,setSizeError] = useState();
    const [fileName,setFileName] = useState()
    const [path,setPath] = useState()
    const data = props.item && props.item.data && JSON.parse(props.item.data ) 
    const type=data.extensions
    const maxSize = data.max_size * 1024;
    const serror=data.sizeError;
    // const max= maxSize.toString();
    console.log("uploadprops",props,data,type,maxSize);
    let name;
   const handleChange = (e) => {
      

       const files1 =e.target.value.split("\\")
       name=files1[files1.length-1]
       
       const file =  e.target.files && e.target.files[0]
       setPath(file);
       setFileName(name)
       const size = file.size;
       if(size > maxSize)
       {setSizeError(serror)
        setShowError(true)}
        else{
            setShowError(false)
       }
       console.log("selectedfile",e.target.files[0].size,files1,files1[files1.length-1]);
       setSelected(name)
       
   }
   useEffect(() => {
       setFileName(name)
   },[props.name])

   const handleUpload = () => {

     
      console.log("uploadData",path);
       apiService.uploadMedia(path).then(response => {
        let data = {key1:response.data.key1}
        data=JSON.stringify(data)
         props.handleClick(props.item.code,data)
        console.log("uploadresponse",response)
       })
   }


    return (
        <>
        <p className="bold" style={{color:'#444444',fontSize:'14px',margin:'0px'}}>Upload File</p>
            <div className="custom-file">
               
                    <input type="file" className="custom-file-input" id="customFile"
                        accept={type.map(i => i)}
                        onChange={handleChange} />
                    <label className="custom-file-label" for="customFile"> {selected} </label>
          {showError &&  <p style={{color:'red',fontSize:'14px'}}>{sizeError}</p>}
						</div>
                        <div className="form-group" style={{marginTop:'20px'}}>
                <div className="btn-contr text-left"> 
                    <a className="btn btn-primary waves-effect waves-light" href="#!" style={{fontSize:"15px"}} onClick={()=>{ handleUpload();props.setTextOnClick(props.item.text)}}>Upload</a> 
       </div>
                <div className="height50">&nbsp;</div>
            </div>
                        </>
    )


}


export default UploadFile;